module.exports = __webpack_public_path__ + "static/media/cadastro.b1282356.svg";